import { LoadingSpinner } from '../../../components/loading/loading-spinner.tsx';
import Text from '../../../components/ui/text.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { api } from '../../../utils/api.ts';
import { CommentItem } from './comment-item.tsx';
import { NewComment } from './new-comment.tsx';

type CommentsThreadProps = {
    taskId?: string;
    noteId?: string;
};

export const CommentsThread = ({ taskId, noteId }: CommentsThreadProps) => {
    const { t } = useLocale('tasks');

    const { data: commentsData, isLoading } = api.platoUser.query.comments.getManyComments.useQuery(
        taskId ? { taskId } : { noteId: noteId! },
        { refetchInterval: 5000 },
    );

    const comments = commentsData || [];

    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-12">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-3">
            <Text color="neutral-950" weight="medium">
                {t('comments__section_title')}
            </Text>
            {comments.length > 0 && (
                <div className="flex flex-col gap-3">
                    {comments.map((comment) => (
                        <CommentItem key={comment.commentId} comment={comment} />
                    ))}
                </div>
            )}
            <NewComment taskId={taskId} noteId={noteId} />
        </div>
    );
};
